/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSessionFilledQuestions } from './oralExamSessionFilledQuestions';
import type { OralExamSessionQuestion } from './oralExamSessionQuestion';

/**
 * Asked questions for this oral exam session: drawn ids and filled wording.

Thin GET projection of the sealed summary (booking run only if the seal is
absent). Not the task question pool, not a transcript/session log, not the
whole booking.
 */
export interface OralExamSession {
  selectedQuestionIds?: string[];
  filledQuestions?: OralExamSessionFilledQuestions;
  questions?: OralExamSessionQuestion[];
}
